// Should match Enum Website\Platform\AcisHorizon.Web.Framework\UserStateDefaults.cs\UserStateGroup
export const OCCUPANCY_MANAGER_SETTINGS = "OCCUPANCY_MANAGER_SETTINGS";
